export enum CampaignScheduleType {
    MANUAL = 'MANUAL',
    DELAYED = 'DELAYED',
}
